












































































































































































































import Vue from 'vue'
import { FETCH_ADDRESS_WEB_REPORT, SAVE_ADDRESS_WEB_REPORT } from '@/store/action-types'
import ProgressCircular from '@/components/ProgressCircular.vue'
import { TranslateResult } from 'vue-i18n'
import { SnackbarStateEnum } from '@/types/enums'


interface ComponentData {
  reportData: any
  webReportPayload: any
  loading: boolean
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string

  option1: string[]
  option2: string[]
  option3: string[]
}

export default Vue.extend({
  name: 'WebReportPFA',

  components: {
    ProgressCircular
  },

  props: {
    show: Boolean,
    selectedAddressId: Number
  },

  data (): ComponentData {
    return {
      reportData: undefined,
      webReportPayload: undefined,
      loading: false,
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',

      option1: [],
      option2: [],
      option3: []
    }
  },

  watch: {

  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    }
  },

  methods: {
    onCloseDialog (): void {
      this.$emit('close')
    },

    onField1Change (data: any): void {
      if(data) {
        const result: number =  this.webReportPayload.i_Wert010 ? parseFloat(this.webReportPayload.i_Wert010) + parseFloat(data) : parseFloat(data)
        if (result <= 0) {
          this.webReportPayload.i_Wert011 = parseFloat('0').toFixed(2)
        } else {
          this.webReportPayload.i_Wert011 = parseFloat(result.toString()).toFixed(2)
        }
      } else {
        const result: number =  this.webReportPayload.i_Wert010 ? parseFloat(this.webReportPayload.i_Wert010) : 0
        if (result <= 0) {
          this.webReportPayload.i_Wert011 = parseFloat('0').toFixed(2)
        } else {
          this.webReportPayload.i_Wert011 = parseFloat(result.toString()).toFixed(2)
        }
      }
    },

    onField2Change (data: any): void {
      if(data) {
        const result: number = this.webReportPayload.i_Wert008 ? parseFloat(this.webReportPayload.i_Wert008) + parseFloat(data) : parseFloat(data)
        if (result <= 0) {
          this.webReportPayload.i_Wert011 = parseFloat('0').toFixed(2)
        } else {
          this.webReportPayload.i_Wert011 = parseFloat(result.toString()).toFixed(2)
        }
      } else {
        const result: number = this.webReportPayload.i_Wert008 ? parseFloat(this.webReportPayload.i_Wert008) : 0
        if (result <= 0) {
          this.webReportPayload.i_Wert011 = parseFloat('0').toFixed(2)
        } else {
          this.webReportPayload.i_Wert011 = parseFloat(result.toString()).toFixed(2)
        }
      }
    },

    onFieldTotalChange (data: any): void {
      if(this.webReportPayload.i_Wert008 && this.webReportPayload.i_Wert010) {
        const result: number = parseFloat(this.webReportPayload.i_Wert008) + parseFloat(this.webReportPayload.i_Wert010)
        if (result <= 0) {
          this.webReportPayload.i_Wert011 = parseFloat('0').toFixed(2)
        } else {
          this.webReportPayload.i_Wert011 = parseFloat(result.toString()).toFixed(2)
        }
      } else if (this.webReportPayload.i_Wert008 && !this.webReportPayload.i_Wert010) {
        const result: number = parseFloat(this.webReportPayload.i_Wert008)
        if (result <= 0) {
          this.webReportPayload.i_Wert011 = parseFloat('0').toFixed(2)
        } else {
          this.webReportPayload.i_Wert011 = parseFloat(result.toString()).toFixed(2)
        }
      } else if (!this.webReportPayload.i_Wert008 && this.webReportPayload.i_Wert010) {
        const result: number = parseFloat(this.webReportPayload.i_Wert010)
        if (result <= 0) {
          this.webReportPayload.i_Wert011 = parseFloat('0').toFixed(2)
        } else {
          this.webReportPayload.i_Wert011 = parseFloat(result.toString()).toFixed(2)
        }
      } else {
        this.webReportPayload.i_Wert011 = parseFloat('0').toFixed(2)
      }
    },

    onSaveClick (): void {
      for (const item in this.webReportPayload) {
        if(this.webReportPayload[item] === true) {
          this.webReportPayload[item] = "Ja"
        } else if(this.webReportPayload[item] === false) {
          this.webReportPayload[item] = ""
        }
      }

      const payload: any =  {
        AddressId: this.selectedAddressId,
        FormName: "Pflichtenheft",
        Values: this.webReportPayload
      }

      this.saveWebReport(payload)
    },

    async saveWebReport (payload: any): Promise<void> {
      try {
        this.loading = true
        const response: any = await this.$store.dispatch(SAVE_ADDRESS_WEB_REPORT, payload)
        this.loading = false
        if(response.IsError) {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        } else {
          this.$emit('saved')
        }
      } catch (e) {
        this.loading = false
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    setData (data: any): void {
      this.webReportPayload = data

      this.webReportPayload.i_Wert003 = this.webReportPayload.ZFAnzZimmer === '' || this.webReportPayload.ZFAnzZimmer === '0' ? this.webReportPayload.i_Wert003 : this.webReportPayload.ZFAnzZimmer
      this.webReportPayload.i_Wert004 = this.webReportPayload.ZFZimmer === '' || this.webReportPayload.ZFAnzZimmer === '0' ? this.webReportPayload.i_Wert004 : this.webReportPayload.ZFZimmer
      this.webReportPayload.i_Wert012 = this.webReportPayload.ZFEinsatztage === '' ? this.webReportPayload.i_Wert012 : this.webReportPayload.ZFEinsatztage
      this.webReportPayload.i_Wert005 = this.webReportPayload.ZFEtage === '' || this.webReportPayload.ZFEtage === '0' ? this.webReportPayload.i_Wert005 : this.webReportPayload.ZFEtage
      this.webReportPayload.i_Wert013 = this.webReportPayload.ZFEinsatzzeit === '' ? this.webReportPayload.i_Wert013 : this.webReportPayload.ZFEinsatzzeit
      this.webReportPayload.i_Wert018 = this.webReportPayload.ZFStockwerke === '' ? this.webReportPayload.i_Wert018 : this.webReportPayload.ZFStockwerke
      this.webReportPayload.i_Wert019 = this.webReportPayload.ZFStockwerke === '' ? this.webReportPayload.i_Wert019 : this.webReportPayload.ZFStockwerke
      this.webReportPayload.i_Wert015 = this.webReportPayload.ZFEinsatzrhythmus === '' ? this.webReportPayload.i_Wert015 : this.webReportPayload.ZFEinsatzrhythmus


      this.reportData = {
        headerLeft: [
          {id: 1, label: 'Kunde:', value: `${this.webReportPayload.KDVorname} ${this.webReportPayload.KDName}`},
          {id: 2, label: 'Kundennummer:', value: this.webReportPayload.Kundennummer},
          {id: 3, label: 'Anzahl Zimmer:', value: 'i_Wert003', value2: 'i_Wert004'},
          {id: 4, label: 'Etage:', value: 'i_Wert005', value2: 'i_Wert006' },
          {id: 5, label: 'Anzahl Stockwerke:', value: 'i_Wert018', value2: 'i_Wert019' },
          {id: 6, label: 'Haustiere:', value: 'i_Wert020'}
        ],

        headerRight: [
          {id: 7, label: 'Einsatzdauer Basis in Stunden:', value: 'i_Wert008'},
          {id: 8, label: 'Einsatzdauer Zusatz in Stunden:', value: 'i_Wert010', value2: 'i_Wert011' },
          {id: 9, label: 'Einsatztag:', value: 'i_Wert012'},
          {id: 10, label: 'Einsatzzeit:', value: 'i_Wert013'},
          {id: 11, label: 'Putzfrau:', value: `${this.webReportPayload.PFVorname} ${this.webReportPayload.PFName}`},
          {id: 12, label: 'Rhythmus:', value: 'i_Wert015'}
        ],

        detailListLeft: [
          {id: 1, detailLabel: 'Nasszellen (Bad / Dusche / Toilette)', fieldList: [
              {id: 1, label: 'i_Wert021', value1: 'i_Wert022', value2: 'i_Wert023', value3: 'i_Wert024', value4: 'i_Wert025', value5: 'i_Wert026'},
              {id: 2, label: 'i_Wert033', value1: 'i_Wert034', value2: 'i_Wert035', value3: 'i_Wert036', value4: 'i_Wert037', value5: 'i_Wert038'},
              {id: 3, label: 'i_Wert045', value1: 'i_Wert046', value2: 'i_Wert047', value3: 'i_Wert048', value4: 'i_Wert049', value5: 'i_Wert050'},
              {id: 4, label: 'i_Wert057', value1: 'i_Wert058', value2: 'i_Wert059', value3: 'i_Wert060', value4: 'i_Wert061', value5: 'i_Wert062'},
              {id: 5, label: 'i_Wert069', value1: 'i_Wert070', value2: 'i_Wert071', value3: 'i_Wert072', value4: 'i_Wert073', value5: 'i_Wert074'},
              {id: 6, label: 'i_Wert081', value1: 'i_Wert082', value2: 'i_Wert083', value3: 'i_Wert084', value4: 'i_Wert085', value5: 'i_Wert086'},
              {id: 7, label: 'i_Wert093', value1: 'i_Wert094', value2: 'i_Wert095', value3: 'i_Wert096', value4: 'i_Wert097', value5: 'i_Wert098'},
              {id: 8, label: 'i_Wert105', value1: 'i_Wert106', value2: 'i_Wert107', value3: 'i_Wert108', value4: 'i_Wert109', value5: 'i_Wert110'},
              {id: 9, label: 'i_Wert117', value1: 'i_Wert118', value2: 'i_Wert119', value3: 'i_Wert120', value4: 'i_Wert121', value5: 'i_Wert122'},
              {id: 10, label: 'i_Wert129', value1: 'i_Wert130', value2: 'i_Wert131', value3: 'i_Wert132', value4: 'i_Wert133', value5: 'i_Wert134'},
              {id: 11, label: 'i_Wert141', value1: 'i_Wert142', value2: 'i_Wert143', value3: 'i_Wert144', value4: 'i_Wert145', value5: 'i_Wert146'},
              {id: 12, label: 'i_Wert153', value1: 'i_Wert154', value2: 'i_Wert155', value3: 'i_Wert156', value4: 'i_Wert157', value5: 'i_Wert158'},
              {id: 13, label: 'i_Wert165', value1: 'i_Wert166', value2: 'i_Wert167', value3: 'i_Wert168', value4: 'i_Wert169', value5: 'i_Wert170'},
              {id: 14, label: 'i_Wert177', value1: 'i_Wert178', value2: 'i_Wert179', value3: 'i_Wert180', value4: 'i_Wert181', value5: 'i_Wert182'},
              {id: 15, label: 'i_Wert189', value1: 'i_Wert190', value2: 'i_Wert191', value3: 'i_Wert192', value4: 'i_Wert193', value5: 'i_Wert194'},
              {id: 16, label: 'i_Wert200', value1: 'i_Wert201', value2: 'i_Wert202', value3: 'i_Wert203', value4: 'i_Wert204', value5: 'i_Wert205'}
            ]},
          {id: 2, detailLabel: 'Gang, etc.', fieldList: [
              {id: 20, label: 'i_Wert213', value1: 'i_Wert214', value2: 'i_Wert215', value3: 'i_Wert216', value4: 'i_Wert217', value5: 'i_Wert218'},
              {id: 21, label: 'i_Wert225', value1: 'i_Wert226', value2: 'i_Wert227', value3: 'i_Wert228', value4: 'i_Wert229', value5: 'i_Wert230'},
              {id: 22, label: 'i_Wert237', value1: 'i_Wert238', value2: 'i_Wert239', value3: 'i_Wert240', value4: 'i_Wert241', value5: 'i_Wert242'},
              {id: 23, label: 'i_Wert249', value1: 'i_Wert250', value2: 'i_Wert251', value3: 'i_Wert252', value4: 'i_Wert253', value5: 'i_Wert254'},
              {id: 24, label: 'i_Wert261', value1: 'i_Wert262', value2: 'i_Wert263', value3: 'i_Wert264', value4: 'i_Wert265', value5: 'i_Wert266'}
            ]},
          {id: 3, detailLabel: 'Übrige Zimmer (Schlafzimmer, Büro, etc.)', fieldList: [
              {id: 30, label: 'i_Wert272', value1: 'i_Wert273', value2: 'i_Wert274', value3: 'i_Wert275', value4: 'i_Wert276', value5: 'i_Wert277'},
              {id: 31, label: 'i_Wert284', value1: 'i_Wert285', value2: 'i_Wert286', value3: 'i_Wert287', value4: 'i_Wert288', value5: 'i_Wert289'},
              {id: 32, label: 'i_Wert296', value1: 'i_Wert297', value2: 'i_Wert298', value3: 'i_Wert299', value4: 'i_Wert300', value5: 'i_Wert301'},
              {id: 33, label: 'i_Wert308', value1: 'i_Wert309', value2: 'i_Wert310', value3: 'i_Wert311', value4: 'i_Wert312', value5: 'i_Wert313'},
              {id: 34, label: 'i_Wert320', value1: 'i_Wert321', value2: 'i_Wert322', value3: 'i_Wert323', value4: 'i_Wert324', value5: 'i_Wert325'},
              {id: 35, label: 'i_Wert332', value1: 'i_Wert333', value2: 'i_Wert334', value3: 'i_Wert335', value4: 'i_Wert336', value5: 'i_Wert337'},
              {id: 36, label: 'i_Wert344', value1: 'i_Wert345', value2: 'i_Wert346', value3: 'i_Wert347', value4: 'i_Wert348', value5: 'i_Wert349'},
              {id: 37, label: 'i_Wert356', value1: 'i_Wert357', value2: 'i_Wert358', value3: 'i_Wert359', value4: 'i_Wert360', value5: 'i_Wert361'},
              {id: 38, label: 'i_Wert368', value1: 'i_Wert369', value2: 'i_Wert370', value3: 'i_Wert371', value4: 'i_Wert372', value5: 'i_Wert373'},
            ]},
          {id: 4, detailLabel: 'i_Wert386', fieldList: [
              {id: 40, label: 'i_Wert387', value1: 'i_Wert388', value2: 'i_Wert389', value3: 'i_Wert390', value4: 'i_Wert391', value5: 'i_Wert392'},
              {id: 41, label: 'i_Wert399', value1: 'i_Wert400', value2: 'i_Wert401', value3: 'i_Wert402', value4: 'i_Wert403', value5: 'i_Wert404'},
              {id: 42, label: 'i_Wert411', value1: 'i_Wert412', value2: 'i_Wert413', value3: 'i_Wert414', value4: 'i_Wert415', value5: 'i_Wert416'},
              {id: 43, label: 'i_Wert423', value1: 'i_Wert425', value2: 'i_Wert426', value3: 'i_Wert427', value4: 'i_Wert428', value5: 'i_Wert429'},
              {id: 44, label: 'i_Wert430', value1: 'i_Wert431', value2: 'i_Wert432', value3: 'i_Wert433', value4: 'i_Wert434', value5: 'i_Wert435'},
              {id: 45, label: 'i_Wert442', value1: 'i_Wert443', value2: 'i_Wert444', value3: 'i_Wert445', value4: 'i_Wert446', value5: 'i_Wert447'},
            ]},
          {id: 5, detailLabel: 'Bodenbeläge', fieldList: [
              {id: 50, label: 'Geölter Parkett', value1: 'i_Wert460', value2: 'i_Wert461', value3: 'i_Wert462', value4: 'i_Wert463', value5: 'i_Wert464'},
              {id: 51, label: 'Versiegelter Parkett', value1: 'i_Wert465', value2: 'i_Wert466', value3: 'i_Wert467', value4: 'i_Wert468', value5: 'i_Wert469'},
              {id: 52, label: 'Laminat', value1: 'i_Wert470', value2: 'i_Wert471', value3: 'i_Wert472', value4: 'i_Wert473', value5: 'i_Wert474'},
              {id: 53, label: 'Keramikplatten', value1: 'i_Wert475', value2: 'i_Wert476', value3: 'i_Wert477', value4: 'i_Wert478', value5: 'i_Wert479'},
              {id: 54, label: 'Feinstein', value1: 'i_Wert480', value2: 'i_Wert481', value3: 'i_Wert482', value4: 'i_Wert483', value5: 'i_Wert484'},
              {id: 55, label: 'Schieferplatten', value1: 'i_Wert485', value2: 'i_Wert486', value3: 'i_Wert487', value4: 'i_Wert488', value5: 'i_Wert489'},
              {id: 56, label: 'PVC', value1: 'i_Wert491', value2: 'i_Wert492', value3: 'i_Wert493', value4: 'i_Wert494', value5: 'i_Wert495'},
              {id: 57, label: 'i_Wert490', value1: 'i_Wert496', value2: 'i_Wert497', value3: 'i_Wert498', value4: 'i_Wert499', value5: 'i_Wert500'},
              {id: 58, label: 'i_Wert503', value1: 'i_Wert501', value2: 'i_Wert502', value3: 'i_Wert504', value4: 'i_Wert505', value5: 'i_Wert506'},
            ]}

        ],

        detailListRight: [
          {id: 1, detailLabel: 'Küche', fieldList: [
              {id: 1, label: 'i_Wert027', value1: 'i_Wert028', value2: 'i_Wert029', value3: 'i_Wert030', value4: 'i_Wert031', value5: 'i_Wert032'},
              {id: 2, label: 'i_Wert039', value1: 'i_Wert040', value2: 'i_Wert041', value3: 'i_Wert042', value4: 'i_Wert043', value5: 'i_Wert044'},
              {id: 3, label: 'i_Wert051', value1: 'i_Wert052', value2: 'i_Wert053', value3: 'i_Wert054', value4: 'i_Wert055', value5: 'i_Wert056'},
              {id: 4, label: 'i_Wert063', value1: 'i_Wert064', value2: 'i_Wert065', value3: 'i_Wert066', value4: 'i_Wert067', value5: 'i_Wert068'},
              {id: 5, label: 'i_Wert075', value1: 'i_Wert076', value2: 'i_Wert077', value3: 'i_Wert078', value4: 'i_Wert079', value5: 'i_Wert080'},
              {id: 6, label: 'i_Wert087', value1: 'i_Wert088', value2: 'i_Wert089', value3: 'i_Wert090', value4: 'i_Wert091', value5: 'i_Wert092'},
              {id: 7, label: 'i_Wert099', value1: 'i_Wert100', value2: 'i_Wert101', value3: 'i_Wert102', value4: 'i_Wert103', value5: 'i_Wert104'},
              {id: 8, label: 'i_Wert111', value1: 'i_Wert112', value2: 'i_Wert113', value3: 'i_Wert114', value4: 'i_Wert115', value5: 'i_Wert116'},
              {id: 9, label: 'i_Wert123', value1: 'i_Wert124', value2: 'i_Wert125', value3: 'i_Wert126', value4: 'i_Wert127', value5: 'i_Wert128'},
              {id: 10, label: 'i_Wert135', value1: 'i_Wert136', value2: 'i_Wert137', value3: 'i_Wert138', value4: 'i_Wert139', value5: 'i_Wert140'},
              {id: 11, label: 'i_Wert147', value1: 'i_Wert148', value2: 'i_Wert149', value3: 'i_Wert150', value4: 'i_Wert151', value5: 'i_Wert152'},
              {id: 12, label: 'i_Wert159', value1: 'i_Wert160', value2: 'i_Wert161', value3: 'i_Wert162', value4: 'i_Wert163', value5: 'i_Wert164'},
              {id: 13, label: 'i_Wert171', value1: 'i_Wert172', value2: 'i_Wert173', value3: 'i_Wert174', value4: 'i_Wert175', value5: 'i_Wert176'},
              {id: 14, label: 'i_Wert183', value1: 'i_Wert184', value2: 'i_Wert185', value3: 'i_Wert186', value4: 'i_Wert187', value5: 'i_Wert188'},
              {id: 15, label: 'Schränke + Schubladen innen (Frühjahrsputz)', value1: 'i_Wert195', value2: 'i_Wert196', value3: 'i_Wert197', value4: 'i_Wert198', value5: 'i_Wert199'},
              {id: 16, label: 'i_Wert207', value1: 'i_Wert208', value2: 'i_Wert209', value3: 'i_Wert210', value4: 'i_Wert211', value5: 'i_Wert212'}
            ]},
          {id: 2, detailLabel: 'Sonstiges', fieldList: [
              {id: 20, label: 'i_Wert219', value1: 'i_Wert220', value2: 'i_Wert221', value3: 'i_Wert222', value4: 'i_Wert223', value5: 'i_Wert224'},
              {id: 21, label: 'i_Wert231', value1: 'i_Wert232', value2: 'i_Wert233', value3: 'i_Wert234', value4: 'i_Wert235', value5: 'i_Wert236'},
              {id: 22, label: 'i_Wert243', value1: 'i_Wert244', value2: 'i_Wert245', value3: 'i_Wert246', value4: 'i_Wert247', value5: 'i_Wert248'},
              {id: 23, label: 'i_Wert255', value1: 'i_Wert256', value2: 'i_Wert257', value3: 'i_Wert258', value4: 'i_Wert259', value5: 'i_Wert260'},
              {id: 24, label: 'Fenster inkl. Griffe + Rollläden (Frühjahrsputz)', value1: 'i_Wert267', value2: 'i_Wert268', value3: 'i_Wert269', value4: 'i_Wert270', value5: 'i_Wert271'}
            ]},
          {id: 3, detailLabel: 'Wohnzimmer', fieldList: [
              {id: 30, label: 'i_Wert278', value1: 'i_Wert279', value2: 'i_Wert280', value3: 'i_Wert281', value4: 'i_Wert282', value5: 'i_Wert283'},
              {id: 31, label: 'i_Wert290', value1: 'i_Wert291', value2: 'i_Wert292', value3: 'i_Wert293', value4: 'i_Wert294', value5: 'i_Wert295'},
              {id: 32, label: 'i_Wert302', value1: 'i_Wert303', value2: 'i_Wert304', value3: 'i_Wert305', value4: 'i_Wert306', value5: 'i_Wert307'},
              {id: 33, label: 'i_Wert314', value1: 'i_Wert315', value2: 'i_Wert316', value3: 'i_Wert317', value4: 'i_Wert318', value5: 'i_Wert319'},
              {id: 34, label: 'i_Wert326', value1: 'i_Wert327', value2: 'i_Wert328', value3: 'i_Wert329', value4: 'i_Wert330', value5: 'i_Wert331'},
              {id: 35, label: 'i_Wert338', value1: 'i_Wert339', value2: 'i_Wert340', value3: 'i_Wert341', value4: 'i_Wert342', value5: 'i_Wert343'},
              {id: 36, label: 'i_Wert350', value1: 'i_Wert351', value2: 'i_Wert352', value3: 'i_Wert353', value4: 'i_Wert354', value5: 'i_Wert355'},
              {id: 37, label: 'i_Wert362', value1: 'i_Wert363', value2: 'i_Wert364', value3: 'i_Wert365', value4: 'i_Wert366', value5: 'i_Wert367'},
              {id: 38, label: 'i_Wert374', value1: 'i_Wert375', value2: 'i_Wert376', value3: 'i_Wert377', value4: 'i_Wert378', value5: 'i_Wert379'},
              {id: 39, label: 'i_Wert380', value1: 'i_Wert381', value2: 'i_Wert382', value3: 'i_Wert383', value4: 'i_Wert384', value5: 'i_Wert385'},
              {id: 40, label: 'i_Wert393', value1: 'i_Wert394', value2: 'i_Wert395', value3: 'i_Wert396', value4: 'i_Wert397', value5: 'i_Wert398'},
              {id: 41, label: 'i_Wert405', value1: 'i_Wert406', value2: 'i_Wert407', value3: 'i_Wert408', value4: 'i_Wert409', value5: 'i_Wert410'},
              {id: 42, label: 'i_Wert417', value1: 'i_Wert418', value2: 'i_Wert419', value3: 'i_Wert420', value4: 'i_Wert421', value5: 'i_Wert422'},
            ]},
          {id: 4, detailLabel: 'i_Wert424', fieldList: [
              {id: 50, label: 'i_Wert436', value1: 'i_Wert437', value2: 'i_Wert438', value3: 'i_Wert439', value4: 'i_Wert440', value5: 'i_Wert441'},
              {id: 51, label: 'i_Wert448', value1: 'i_Wert449', value2: 'i_Wert450', value3: 'i_Wert451', value4: 'i_Wert452', value5: 'i_Wert453'},
              {id: 52, label: 'i_Wert454', value1: 'i_Wert455', value2: 'i_Wert456', value3: 'i_Wert457', value4: 'i_Wert458', value5: 'i_Wert459'},
            ]},
          {id: 5, detailLabel: 'Legende:', fieldList: [
              {id: 60, label: 'Wohnzimmer', value1: 'W'},
              {id: 61, label: 'Zimmer', value1: 'Z'},
              {id: 62, label: 'Gang', value1: 'G'},
              {id: 63, label: 'Küche', value1: 'K'},
              {id: 64, label: 'Nasszellen', value1: 'N'},
            ]}
        ]
      }
    },

    async fetchData (): Promise<void> {
      try {
        this.loading = true
        const response: any = await this.$store.dispatch(FETCH_ADDRESS_WEB_REPORT, this.selectedAddressId)
        this.loading = false
        if(response) {
          for (const key in response) {
            if(response[key] === 'Off') {
              response[key] = ''
            }
          }
          this.setData(response)
        }
      } catch (e) {
        this.loading = false
      }
    }
  },

  mounted () {
    for (let i = 1; i <= 10; i = i + 0.5) {
      this.option1.push(i.toFixed(1).toString())
    }

    for (let i = 0; i <= 50; i++) {
      this.option2.push(i.toString())
    }

    for (let i = 1; i <= 10 ; i++) {
      this.option3.push(i.toString())
    }

    this.fetchData()
    //this.data = {     "HeaderID": 658,     "AdressID": 162304,     "Kundennummer": "3042",     "KDName": "Lutz",     "KDVorname": "Kerstin",     "DEF_Order": 162304,     "DEF_ID": 162304,     "i_Wert001": "",     "i_Wert002": "",     "i_Wert003": "4.5",     "i_Wert004": "4.5",     "i_Wert005": "2",     "i_Wert006": "",     "i_Wert007": "Lutz Kerstin, Hergiswil ",     "i_Wert008": "3.5",     "i_Wert009": "3042 ",     "i_Wert010": "",     "i_Wert011": "3.5",     "i_Wert012": "",     "i_Wert013": "",     "i_Wert014": "",     "i_Wert015": "",     "i_Wert016": "1",     "i_Wert017": "2",     "i_Wert018": "1",     "i_Wert019": "1",     "i_Wert020": "",     "i_Wert021": "Abfalleimer in Küchenabfall leeren",     "i_Wert022": "",     "i_Wert023": "Ja",     "i_Wert024": "",     "i_Wert025": "",     "i_Wert026": "",     "i_Wert027": "Abfalleimer in Abfallcontainer leeren",     "i_Wert028": "",     "i_Wert029": "",     "i_Wert030": "",     "i_Wert031": "",     "i_Wert032": "",     "i_Wert033": "Wasserhähne polieren",     "i_Wert034": "",     "i_Wert035": "Ja",     "i_Wert036": "",     "i_Wert037": "",     "i_Wert038": "",     "i_Wert039": "Ablageflächen",     "i_Wert040": "",     "i_Wert041": "Ja",     "i_Wert042": "",     "i_Wert043": "",     "i_Wert044": "",     "i_Wert045": "Badewanne nicht mit Biostein ",     "i_Wert046": "",     "i_Wert047": "",     "i_Wert048": "",     "i_Wert049": "Ja",     "i_Wert050": "",     "i_Wert051": "Wasserhähne und Spültrog polieren",     "i_Wert052": "",     "i_Wert053": "Ja",     "i_Wert054": "",     "i_Wert055": "",     "i_Wert056": "",     "i_Wert057": "Duschkabine",     "i_Wert058": "",     "i_Wert059": "Ja",     "i_Wert060": "",     "i_Wert061": "",     "i_Wert062": "",     "i_Wert063": "Geschirr abwaschen / in Maschine einräumen",     "i_Wert064": "",     "i_Wert065": "",     "i_Wert066": "",     "i_Wert067": "Ja",     "i_Wert068": "",     "i_Wert069": "Fliesen entkalken",     "i_Wert070": "",     "i_Wert071": "Ja",     "i_Wert072": "",     "i_Wert073": "",     "i_Wert074": "",     "i_Wert075": "Herdplatte",     "i_Wert076": "",     "i_Wert077": "Ja",     "i_Wert078": "",     "i_Wert079": "",     "i_Wert080": "",     "i_Wert081": "Lavabo inkl. Zahngläser + Seifenschalen nicht mit Biost.",     "i_Wert082": "",     "i_Wert083": "Ja",     "i_Wert084": "",     "i_Wert085": "",     "i_Wert086": "",     "i_Wert087": "Kacheln entfetten",     "i_Wert088": "",     "i_Wert089": "Ja",     "i_Wert090": "",     "i_Wert091": "",     "i_Wert092": "",     "i_Wert093": "Lüftung / Abzug",     "i_Wert094": "",     "i_Wert095": "",     "i_Wert096": "",     "i_Wert097": "",     "i_Wert098": "",     "i_Wert099": "Schränke/Schubladen inkl. Elektrogeräte aussen",     "i_Wert100": "",     "i_Wert101": "Ja",     "i_Wert102": "",     "i_Wert103": "",     "i_Wert104": "",     "i_Wert105": "Radiator für Frottetücher abstauben",     "i_Wert106": "",     "i_Wert107": "Ja",     "i_Wert108": "",     "i_Wert109": "",     "i_Wert110": "",     "i_Wert111": "Staubsaugen (inkl. Bodenleisten)",     "i_Wert112": "",     "i_Wert113": "Ja",     "i_Wert114": "",     "i_Wert115": "",     "i_Wert116": "",     "i_Wert117": "Spiegel (Vorder- und Rückseite)",     "i_Wert118": "",     "i_Wert119": "Ja",     "i_Wert120": "",     "i_Wert121": "",     "i_Wert122": "",     "i_Wert123": "Boden feucht aufnehmen",     "i_Wert124": "",     "i_Wert125": "Ja",     "i_Wert126": "",     "i_Wert127": "",     "i_Wert128": "",     "i_Wert129": "Staubsaugen (inkl. Bodenleisten)",     "i_Wert130": "",     "i_Wert131": "Ja",     "i_Wert132": "",     "i_Wert133": "",     "i_Wert134": "",     "i_Wert135": "Abfalleimer reinigen",     "i_Wert136": "",     "i_Wert137": "",     "i_Wert138": "",     "i_Wert139": "Ja",     "i_Wert140": "",     "i_Wert141": "Boden feucht aufnehmen",     "i_Wert142": "",     "i_Wert143": "Ja",     "i_Wert144": "",     "i_Wert145": "",     "i_Wert146": "",     "i_Wert147": "Backofen / Mikrowelle",     "i_Wert148": "",     "i_Wert149": "",     "i_Wert150": "",     "i_Wert151": "Ja",     "i_Wert152": "",     "i_Wert153": "Toilette innen und aussen",     "i_Wert154": "",     "i_Wert155": "Ja",     "i_Wert156": "",     "i_Wert157": "",     "i_Wert158": "",     "i_Wert159": "Dampfabzug",     "i_Wert160": "",     "i_Wert161": "",     "i_Wert162": "",     "i_Wert163": "Ja",     "i_Wert164": "",     "i_Wert165": "Vorleger ausschütteln oder absaugen",     "i_Wert166": "",     "i_Wert167": "",     "i_Wert168": "",     "i_Wert169": "",     "i_Wert170": "",     "i_Wert171": "Kühlschrank",     "i_Wert172": "",     "i_Wert173": "",     "i_Wert174": "",     "i_Wert175": "Ja",     "i_Wert176": "",     "i_Wert177": "WC-Papier und WC-Stein nachfüllen",     "i_Wert178": "",     "i_Wert179": "",     "i_Wert180": "",     "i_Wert181": "",     "i_Wert182": "",     "i_Wert183": "Wasserhähne und Brausen entkalken",     "i_Wert184": "",     "i_Wert185": "",     "i_Wert186": "",     "i_Wert187": "",     "i_Wert188": "",     "i_Wert189": "Spiegelschrank innenseitig säubern",     "i_Wert190": "",     "i_Wert191": "",     "i_Wert192": "",     "i_Wert193": "",     "i_Wert194": "Ja",     "i_Wert195": "",     "i_Wert196": "",     "i_Wert197": "",     "i_Wert198": "",     "i_Wert199": "Ja",     "i_Wert200": "Wasserhähne und Brausen entkalken",     "i_Wert201": "",     "i_Wert202": "",     "i_Wert203": "",     "i_Wert204": "",     "i_Wert205": "",     "i_Wert206": "",     "i_Wert207": "",     "i_Wert208": "",     "i_Wert209": "",     "i_Wert210": "",     "i_Wert211": "",     "i_Wert212": "",     "i_Wert213": "Bilder abstauben",     "i_Wert214": "",     "i_Wert215": "",     "i_Wert216": "",     "i_Wert217": "",     "i_Wert218": "",     "i_Wert219": "Entfernen von Spinnweben an den Decken",     "i_Wert220": "",     "i_Wert221": "",     "i_Wert222": "",     "i_Wert223": "Ja",     "i_Wert224": "",     "i_Wert225": "Möbel abstauben",     "i_Wert226": "",     "i_Wert227": "Ja",     "i_Wert228": "",     "i_Wert229": "",     "i_Wert230": "",     "i_Wert231": "Fleckenentfernung an Wänden, Möbeln etc.",     "i_Wert232": "",     "i_Wert233": "",     "i_Wert234": "",     "i_Wert235": "",     "i_Wert236": "",     "i_Wert237": "Spiegel reinigen",     "i_Wert238": "",     "i_Wert239": "",     "i_Wert240": "",     "i_Wert241": "",     "i_Wert242": "",     "i_Wert243": "Schalter und Dosen",     "i_Wert244": "",     "i_Wert245": "",     "i_Wert246": "",     "i_Wert247": "Ja",     "i_Wert248": "",     "i_Wert249": "Staubsaugen",     "i_Wert250": "",     "i_Wert251": "Ja",     "i_Wert252": "",     "i_Wert253": "",     "i_Wert254": "",     "i_Wert255": "Türen inkl. Griffe und Zargen",     "i_Wert256": "",     "i_Wert257": "",     "i_Wert258": "",     "i_Wert259": "Ja",     "i_Wert260": "",     "i_Wert261": "Boden feucht aufnehmen",     "i_Wert262": "",     "i_Wert263": "",     "i_Wert264": "",     "i_Wert265": "Ja",     "i_Wert266": "",     "i_Wert267": "",     "i_Wert268": "",     "i_Wert269": "",     "i_Wert270": "",     "i_Wert271": "Ja",     "i_Wert272": "Abfalleimer in Küchenabfall leeren",     "i_Wert273": "",     "i_Wert274": "",     "i_Wert275": "",     "i_Wert276": "",     "i_Wert277": "",     "i_Wert278": "Abfalleimer in Küchenabfall leeren",     "i_Wert279": "",     "i_Wert280": "",     "i_Wert281": "",     "i_Wert282": "",     "i_Wert283": "",     "i_Wert284": "Bettwäsche wechseln",     "i_Wert285": "",     "i_Wert286": "",     "i_Wert287": "",     "i_Wert288": "",     "i_Wert289": "",     "i_Wert290": "Aschenbecher leeren",     "i_Wert291": "",     "i_Wert292": "",     "i_Wert293": "",     "i_Wert294": "",     "i_Wert295": "",     "i_Wert296": "Geschirr abräumen",     "i_Wert297": "",     "i_Wert298": "",     "i_Wert299": "",     "i_Wert300": "",     "i_Wert301": "",     "i_Wert302": "Stühle trocken abreiben",     "i_Wert303": "",     "i_Wert304": "Ja",     "i_Wert305": "",     "i_Wert306": "",     "i_Wert307": "",     "i_Wert308": "Heizkörper, Simse, Türen, Bilder abstauben",     "i_Wert309": "",     "i_Wert310": "",     "i_Wert311": "",     "i_Wert312": "Ja",     "i_Wert313": "",     "i_Wert314": "Esstisch feucht abwischen",     "i_Wert315": "",     "i_Wert316": "Ja",     "i_Wert317": "",     "i_Wert318": "",     "i_Wert319": "",     "i_Wert320": "Möbel abstauben",     "i_Wert321": "",     "i_Wert322": "Ja",     "i_Wert323": "",     "i_Wert324": "",     "i_Wert325": "",     "i_Wert326": "Geschirr abräumen",     "i_Wert327": "",     "i_Wert328": "",     "i_Wert329": "",     "i_Wert330": "",     "i_Wert331": "",     "i_Wert332": "Pflanzen giessen",     "i_Wert333": "",     "i_Wert334": "",     "i_Wert335": "",     "i_Wert336": "",     "i_Wert337": "",     "i_Wert338": "Heizkörper, Simse, Türen, Bilder etc. abstauben",     "i_Wert339": "",     "i_Wert340": "",     "i_Wert341": "",     "i_Wert342": "Ja",     "i_Wert343": "",     "i_Wert344": "Spiegel reinigen",     "i_Wert345": "",     "i_Wert346": "",     "i_Wert347": "",     "i_Wert348": "",     "i_Wert349": "",     "i_Wert350": "Möbel abstauben",     "i_Wert351": "",     "i_Wert352": "Ja",     "i_Wert353": "",     "i_Wert354": "",     "i_Wert355": "",     "i_Wert356": "Staubsaugen (inkl. Bodenleisten)",     "i_Wert357": "",     "i_Wert358": "Ja",     "i_Wert359": "",     "i_Wert360": "",     "i_Wert361": "",     "i_Wert362": "Polstergruppe saugen",     "i_Wert363": "",     "i_Wert364": "Ja",     "i_Wert365": "",     "i_Wert366": "",     "i_Wert367": "",     "i_Wert368": "Boden feucht aufnehmen",     "i_Wert369": "",     "i_Wert370": "",     "i_Wert371": "",     "i_Wert372": "Ja",     "i_Wert373": "",     "i_Wert374": "Spiegel reinigen",     "i_Wert375": "",     "i_Wert376": "",     "i_Wert377": "",     "i_Wert378": "",     "i_Wert379": "",     "i_Wert380": "Staubsaugen (inkl. Bodenleisten)",     "i_Wert381": "",     "i_Wert382": "Ja",     "i_Wert383": "",     "i_Wert384": "",     "i_Wert385": "",     "i_Wert386": "Gemäss separatem Auftrag",     "i_Wert387": "Balkon, Gartensitzplatz, Terrasse wischen",     "i_Wert388": "",     "i_Wert389": "",     "i_Wert390": "",     "i_Wert391": "Ja",     "i_Wert392": "",     "i_Wert393": "Boden feucht aufnehmen",     "i_Wert394": "",     "i_Wert395": "",     "i_Wert396": "",     "i_Wert397": "Ja",     "i_Wert398": "",     "i_Wert399": "Bügeln:",     "i_Wert400": "",     "i_Wert401": "",     "i_Wert402": "",     "i_Wert403": "",     "i_Wert404": "",     "i_Wert405": "",     "i_Wert406": "",     "i_Wert407": "",     "i_Wert408": "",     "i_Wert409": "",     "i_Wert410": "",     "i_Wert411": "Garagenplatz wischen",     "i_Wert412": "",     "i_Wert413": "",     "i_Wert414": "",     "i_Wert415": "",     "i_Wert416": "",     "i_Wert417": "",     "i_Wert418": "",     "i_Wert419": "",     "i_Wert420": "",     "i_Wert421": "",     "i_Wert422": "",     "i_Wert423": "Schuhe polieren",     "i_Wert424": "Spezielles",     "i_Wert425": "",     "i_Wert426": "",     "i_Wert427": "",     "i_Wert428": "",     "i_Wert429": "",     "i_Wert430": "Tumblern",     "i_Wert431": "",     "i_Wert432": "",     "i_Wert433": "",     "i_Wert434": "",     "i_Wert435": "",     "i_Wert436": "Spezielles",     "i_Wert437": "",     "i_Wert438": "",     "i_Wert439": "",     "i_Wert440": "",     "i_Wert441": "",     "i_Wert442": "Wäsche waschen",     "i_Wert443": "",     "i_Wert444": "",     "i_Wert445": "",     "i_Wert446": "",     "i_Wert447": "",     "i_Wert448": "Katzenbaum absaugen",     "i_Wert449": "",     "i_Wert450": "",     "i_Wert451": "",     "i_Wert452": "",     "i_Wert453": "",     "i_Wert454": "Balkontisch und Stühle reinigen",     "i_Wert455": "",     "i_Wert456": "",     "i_Wert457": "",     "i_Wert458": "",     "i_Wert459": "",     "i_Wert460": "Ja",     "i_Wert461": "Ja",     "i_Wert462": "Ja",     "i_Wert463": "Ja",     "i_Wert464": "",     "i_Wert465": "",     "i_Wert466": "",     "i_Wert467": "",     "i_Wert468": "",     "i_Wert469": "",     "i_Wert470": "",     "i_Wert471": "",     "i_Wert472": "",     "i_Wert473": "",     "i_Wert474": "",     "i_Wert475": "",     "i_Wert476": "",     "i_Wert477": "",     "i_Wert478": "",     "i_Wert479": "",     "i_Wert480": "",     "i_Wert481": "",     "i_Wert482": "",     "i_Wert483": "",     "i_Wert484": "Ja",     "i_Wert485": "",     "i_Wert486": "",     "i_Wert487": "",     "i_Wert488": "",     "i_Wert489": "",     "i_Wert490": "Kork",     "i_Wert491": "",     "i_Wert492": "",     "i_Wert493": "",     "i_Wert494": "",     "i_Wert495": "",     "i_Wert496": "",     "i_Wert497": "",     "i_Wert498": "",     "i_Wert499": "",     "i_Wert500": "",     "i_Wert501": "",     "i_Wert502": "",     "i_Wert503": "Teppich",     "i_Wert504": "",     "i_Wert505": "",     "i_Wert506": "",     "i_Wert507": "",     "i_Feld507": "Standartzusatz",     "i_Wert508": "Ankleide feucht wischen, Türen dürfen geöfnet werden zum saugen, \r",     "i_Feld508": "Bemerkungen",     "i_Wert509": "",     "i_Wert510": "",     "i_Wert511": "",     "i_Wert512": "",     "i_Wert513": "",     "i_Wert514": "",     "i_Wert515": "",     "i_Wert516": "",     "i_Wert517": "",     "i_Wert518": "",     "i_Wert519": "",     "i_Wert520": "",     "i_Wert521": "",     "i_Wert522": "",     "i_Wert523": "",     "i_Wert524": "",     "i_Wert525": "",     "i_Wert526": "",     "i_Wert527": "",     "i_Wert528": "",     "i_Wert529": "",     "i_Wert530": "",     "i_Wert531": "",     "i_Wert532": "",     "i_Wert533": "",     "i_Wert534": "",     "i_Wert535": "",     "i_Wert536": "",     "i_Wert537": "",     "i_Wert538": "",     "i_Wert539": "",     "i_Wert540": "",     "i_Wert541": "",     "i_Wert542": "",     "i_Wert543": "",     "i_Wert544": "",     "i_Wert545": "",     "i_Wert546": "",     "i_Wert547": "",     "i_Wert548": "",     "i_Wert549": "",     "i_Wert550": "",     "i_Wert551": "",     "i_Wert552": "",     "i_Wert553": "",     "i_Wert554": "",     "i_Wert555": "",     "i_Wert556": "",     "i_Wert557": "",     "i_Wert558": "",     "i_Wert559": "",     "i_Wert560": "",     "i_Wert561": "",     "i_Wert562": "",     "i_Wert563": "",     "i_Wert564": "",     "i_Wert565": "",     "i_Wert566": "",     "i_Wert567": "",     "i_Wert568": "",     "i_Wert569": "",     "i_Wert570": "",     "i_Wert571": "",     "i_Wert572": "",     "i_Wert573": "",     "i_Wert574": "",     "i_Wert575": "",     "i_Wert576": "",     "i_Wert577": "",     "i_Wert578": "",     "i_Wert579": "",     "i_Wert580": "",     "i_Wert581": "",     "i_Wert582": "",     "i_Wert583": "",     "i_Wert584": "",     "i_Wert585": "",     "i_Wert586": "",     "i_Wert587": "",     "i_Wert588": "",     "i_Wert589": "",     "i_Wert590": "",     "i_Wert591": "",     "i_Wert592": "",     "i_Wert593": "",     "i_Wert594": "",     "i_Wert595": "",     "i_Wert596": "",     "i_Wert597": "",     "i_Wert598": "",     "i_Wert599": "",     "i_Wert600": null,     "i_Wert601": null,     "i_Wert602": null,     "i_Wert603": null,     "i_Wert604": null,     "i_Wert605": null,     "i_Wert606": null,     "i_Wert607": null,     "i_Wert608": null,     "i_Wert609": null,     "i_Wert610": null,     "i_Wert611": null,     "i_Wert612": null,     "i_Wert613": null,     "i_Wert614": null,     "i_Wert615": null,     "i_Wert616": null,     "i_Wert617": null,     "i_Wert618": null,     "i_Wert619": null,     "i_Wert620": null,     "i_Wert621": null,     "i_Wert622": null,     "i_Wert623": null,     "i_Wert624": null,     "i_Wert625": null,     "i_Wert626": null,     "i_Wert627": null,     "i_Wert628": null,     "i_Wert629": null,     "i_Wert630": null,     "i_Wert631": null,     "i_Wert632": null,     "i_Wert633": null,     "i_Wert634": null,     "i_Wert635": null,     "i_Wert636": null,     "i_Wert637": null,     "i_Wert638": null,     "i_Wert639": null,     "i_Wert640": null,     "i_Wert641": null,     "i_Wert642": null,     "i_Wert643": null,     "i_Wert644": null,     "i_Wert645": null,     "i_Wert646": null,     "i_Wert647": null,     "i_Wert648": null,     "i_Wert649": null,     "i_Wert650": null,     "i_Wert651": null,     "i_Wert652": null,     "i_Wert653": null,     "i_Wert654": null,     "i_Wert655": null,     "i_Wert656": null,     "i_Wert657": null,     "i_Wert658": null,     "i_Wert659": null,     "i_Wert660": null,     "i_Wert661": null,     "i_Wert662": null,     "i_Wert663": null,     "i_Wert664": null,     "i_Wert665": null,     "i_Wert666": null,     "i_Wert667": null,     "i_Wert668": null,     "i_Wert669": null,     "i_Wert670": null,     "i_Wert671": null,     "i_Wert672": null,     "i_Wert673": null,     "i_Wert674": null,     "i_Wert675": null,     "i_Wert676": null,     "i_Wert677": null,     "i_Wert678": null,     "i_Wert679": null,     "i_Wert680": null,     "i_Wert681": null,     "i_Wert682": null,     "i_Wert683": null,     "i_Wert684": null,     "i_Wert685": null,     "i_Wert686": null,     "i_Wert687": null,     "i_Wert688": null,     "i_Wert689": null,     "i_Wert690": null,     "i_Wert691": null,     "i_Wert692": null,     "i_Wert693": null,     "i_Wert694": null,     "i_Wert695": null,     "i_Wert696": null,     "i_Wert697": null,     "i_Wert698": null,     "i_Wert699": null,     "ZFObjekt": "Wohnung",     "ZFZimmer": "4.5",     "ZFm2": "135",     "ZFEinsatztage": " Freitag Freitag",     "ZFEinsatzzeit": "12.30",     "ZFEinsatztotal": "3.5",     "ZFZusatzarbeit": "",     "ZFEinsatzrhythmus": "14-täglich",     "ZFStockwerke": "",     "ZFEtage": "",     "PFVorname": "Sigrid",     "PFName": "Banz-Mathis",     "Sprache": 1,     "ProfitcenterBezeichnung": "Putzfrauenagentur Gnehm GmbH" }
  }
})
